import SvgIcon from '@mui/material/SvgIcon';
export default SvgIcon;
